// Request headers (bearer token, OTP pass token) and request bodies never go
// into a Sentry event; scrubSentryEvent is the backstop in beforeSend.
const FILTERED = '[Filtered]';
const SENSITIVE_KEY_PATTERN = /authorization|cookie|password|secret|token/i;
const BEARER_CREDENTIAL_PATTERN = /Bearer\s+[^\s"',]+/gi;
const MAX_SCRUB_DEPTH = 10;
const SCRUBBED_EVENT_FIELDS = ['extra', 'contexts', 'request', 'breadcrumbs'];
const buildApiErrorExtra = ({ error, endpoint, method }) => ({
    request: { method, endpoint },
    response: {
        status: error?.response?.status ?? error?.code,
        message: error?.message,
        data: error?.response?.data
    }
});
const scrubValue = (value, depth) => {
    if (typeof value === 'string') {
        return value.replace(BEARER_CREDENTIAL_PATTERN, `Bearer ${FILTERED}`);
    }
    if (depth >= MAX_SCRUB_DEPTH || value === null || typeof value !== 'object') {
        return value;
    }
    if (Array.isArray(value)) {
        return value.map((item) => scrubValue(item, depth + 1));
    }
    return Object.fromEntries(Object.entries(value).map(([key, entryValue]) => [
        key,
        SENSITIVE_KEY_PATTERN.test(key)
            ? FILTERED
            : scrubValue(entryValue, depth + 1)
    ]));
};
const scrubSentryEvent = (event) => {
    if (!event)
        return event;
    const scrubbedFields = Object.fromEntries(SCRUBBED_EVENT_FIELDS.filter((field) => field in event).map((field) => [
        field,
        scrubValue(event[field], 0)
    ]));
    return { ...event, ...scrubbedFields };
};
export { buildApiErrorExtra, scrubSentryEvent };
